import { render, staticRenderFns } from "./CityTaxiPricing.vue?vue&type=template&id=13b79aa8"
import script from "./CityTaxiPricing.vue?vue&type=script&lang=js"
export * from "./CityTaxiPricing.vue?vue&type=script&lang=js"
import style0 from "./CityTaxiPricing.vue?vue&type=style&index=0&id=13b79aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports